var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 41,
    viewBox: "0 0 51 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.606 0.104492H6.42418C4.737 0.106297 3.11943 0.777329 1.92641 1.97035C0.733384 3.16337 0.0623517 4.78094 0.0605469 6.46813V33.7409C0.0623517 35.428 0.733384 37.0456 1.92641 38.2386C3.11943 39.4317 4.737 40.1027 6.42418 40.1045H44.606C46.2932 40.1027 47.9108 39.4317 49.1038 38.2386C50.2968 37.0456 50.9678 35.428 50.9696 33.7409V6.46813C50.9678 4.78094 50.2968 3.16337 49.1038 1.97035C47.9108 0.777329 46.2932 0.106297 44.606 0.104492ZM42.9946 10.6306L26.631 23.3579C26.3119 23.606 25.9193 23.7406 25.5151 23.7406C25.1109 23.7406 24.7183 23.606 24.3992 23.3579L8.03555 10.6306C7.84329 10.4854 7.6818 10.3035 7.56047 10.0954C7.43914 9.88721 7.36039 9.65704 7.32878 9.4182C7.29718 9.17936 7.31336 8.93662 7.37638 8.70409C7.4394 8.47156 7.54801 8.25387 7.69589 8.06368C7.84377 7.87348 8.02797 7.71457 8.2378 7.59618C8.44762 7.47779 8.67888 7.40229 8.91814 7.37405C9.1574 7.34581 9.39989 7.3654 9.63151 7.43169C9.86313 7.49797 10.0793 7.60963 10.2674 7.76017L25.5151 19.6193L40.7628 7.76017C41.1441 7.47224 41.6234 7.34596 42.097 7.40864C42.5707 7.47131 43.0006 7.7179 43.2939 8.09509C43.5872 8.47227 43.7202 8.94973 43.6642 9.42422C43.6082 9.89871 43.3677 10.3321 42.9946 10.6306Z",
    fill: "#807B7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector2);
export default __webpack_public_path__ + "static/media/Vector-2.2bae2e1eded7c89b23e0bee3428f5960.svg";
export { ForwardRef as ReactComponent };